import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPorkFeedProduction, getFootprintingPorkFeedProductionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PORK_FEED_PRODUCTION } from "consts";

export const useGetFootprintingPorkFeedProduction = (feedInformationId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PORK_FEED_PRODUCTION, feedInformationId, isAdmin],
      queryFn: () => (isAdmin ? getFootprintingPorkFeedProductionAdmin(feedInformationId ?? "") : getFootprintingPorkFeedProduction(feedInformationId ?? "")),
      enabled: !!feedInformationId,
      staleTime: 0,
      gcTime: 0,
    },
    queryClient
  );
};
